import { render, staticRenderFns } from "./CourseSellingPrice.vue?vue&type=template&id=1696472a&scoped=true"
import script from "./CourseSellingPrice.vue?vue&type=script&lang=js"
export * from "./CourseSellingPrice.vue?vue&type=script&lang=js"
import style0 from "./CourseSellingPrice.vue?vue&type=style&index=0&id=1696472a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1696472a",
  null
  
)

export default component.exports